module.exports = __webpack_public_path__ + "img/event_bg.e6e467dc.png";